import { Box } from '@mui/material';
import { Flex } from '../../../../base/components/Flex';
import { Loader } from '../../../components/Loader';
import QrPageLogo from '../components/QrPageLogo';

const QrLoadingStep = () => {
  return (
    <Flex
      flexDirection="column"
      width="100%"
      minHeight="100%"
      alignItems="center"
      gap={2}
      px={{ xs: 2, md: 6 }}
    >
      <Flex
        flexDirection="column"
        width="100%"
        alignItems={{ xs: 'center', md: 'end' }}
      >
        <QrPageLogo />
      </Flex>

      <Box my="auto">
        <Loader />
      </Box>
    </Flex>
  );
};

export default QrLoadingStep;
